export enum EIndices {
  'ALL' = 0,
  'UNREAD' = 1,
}
